import React, {useCallback, useEffect, useState} from 'react';
import {apiErrorRaised, useApiErrorDispatch} from "../../context/api_error/ApiErrorIndex";
import {useProjectState} from "../../context/project/ProjectIndex";
import {FeedExports} from "../../services/api/FeedExports";
import NotificationAlert from "../Notification/NotificationAlert";
import {closeModal, openModal} from "../../context/modal/ModalActions";
import {useModalDispatch} from "../../context/modal/ModalContext";
import {createFeedExportColumnRenderers} from "./Columns";

const FeedExportItem = ({data, visibleColumns}) => {
  const projectState = useProjectState()
  const dispatch = useApiErrorDispatch();
  const [feedExport, setFeedExport] = useState(feedExportFromData(data));
  const [isRequestExportLoading, setRequestExportLoading] = useState(false)
  const notificationAlertRef = React.useRef(null);
  const modalDispatcher = useModalDispatch()
  const COLUMN_RENDERERS = React.useMemo(() => createFeedExportColumnRenderers(), []);

  const handleRequestExportClick = () => {
    openModal(modalDispatcher, {
      title: 'Request export',
      message: `Do you want to generate feed export: ${feedExport.name}?`,
      onConfirm: () => {
        setRequestExportLoading(true)
        FeedExports.requestExport(projectState.companyId, projectState.projectId, feedExport.id).then((r) => {
          setRequestExportLoading(false);
          if (r === undefined || r.status > 399) {
            apiErrorRaised(dispatch, r?.response)
          }
        });
        closeModal(modalDispatcher)
      },
      onCancel: () => closeModal(modalDispatcher),
      onBackdropClick: () => closeModal(modalDispatcher),
      buttonText: 'Yes'
    })
  }

  function feedExportFromData(data) {
    data.url = process.env.REACT_APP_CDN_URL + 'feeds/' + projectState.projectId + '/' + data.filename + '.' + data.format
    if (data.last_time === null || data.last_time === undefined) {
      data = {
        ...data,
        lastDay: '',
        lastHour: '',
      }
    } else {
      let d = new Date(data.last_time)
      data = {
        ...data,
        lastDay: d.toLocaleDateString(projectState.locale.replace('_', '-'), {timeZone: projectState.timezone}),
        lastHour: d.toLocaleTimeString(projectState.locale.replace('_', '-'), {timeZone: projectState.timezone}),
      }
    }
    return data
  }

  useEffect(() => {
    setFeedExport(feedExportFromData(data))
  }, [data])

  const handleToggle = (e) => {
    const {name, checked} = e.target;
    if (checked) {
      FeedExports.activate(projectState.companyId, projectState.projectId, feedExport.id).then((r) => {
        if (r?.status < 400) {
          setFeedExport(feedExport => ({...feedExport, [name]: checked}))
        } else {
          apiErrorRaised(dispatch, r?.response)
        }
      });
    } else {
      FeedExports.disable(projectState.companyId, projectState.projectId, feedExport.id).then((r) => {
        if (r?.status < 400) {
          setFeedExport(feedExport => ({...feedExport, [name]: checked}))
        } else {
          apiErrorRaised(dispatch, r?.response)
        }
      });
    }
  }

  const getColumnProps = useCallback((columnId) => {
    const baseProps = {feedExport, projectState};

    // Add column-specific props
    switch (columnId) {
      case 'actions':
        return {
          ...baseProps,
          handleToggle,
          handleRequestExportClick,
          isRequestExportLoading,
        };
      default:
        return baseProps;
    }
  }, [feedExport, projectState, handleToggle]);

  return (
    <>
      <NotificationAlert ref={notificationAlertRef}/>
      <tr>
        {visibleColumns.map(columnId => {
          const renderColumn = COLUMN_RENDERERS[columnId];
          if (!renderColumn) return null;

          const props = getColumnProps(columnId);
          return (
            <React.Fragment key={columnId}>
              {renderColumn(props)}
            </React.Fragment>
          );
        })}
      </tr>
    </>
  )
}

export default FeedExportItem;
